/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AssignmentsPatch } from '../models/AssignmentsPatch';
import type { AssignmentsPatchResponse } from '../models/AssignmentsPatchResponse';
import type { CostProfileCreate } from '../models/CostProfileCreate';
import type { CostProfileRead } from '../models/CostProfileRead';
import type { CostProfileUpdate } from '../models/CostProfileUpdate';
import type { HeadcountPatch } from '../models/HeadcountPatch';
import type { HeadcountPatchResponse } from '../models/HeadcountPatchResponse';
import type { OrgAssignmentsPatch } from '../models/OrgAssignmentsPatch';
import type { OrgAssignmentsPatchResponse } from '../models/OrgAssignmentsPatchResponse';
import type { OrgCreate } from '../models/OrgCreate';
import type { OrgRead } from '../models/OrgRead';
import type { WireframeAuditRead } from '../models/WireframeAuditRead';
import type { WireframeDataResponse } from '../models/WireframeDataResponse';
import type { WireframeReportResponse } from '../models/WireframeReportResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AdminWireframeService {

    /**
     * Get Wireframe Data
     * @param timeframe H1 FY26 or H2 FY26 planning root.
     * @returns WireframeDataResponse Successful Response
     * @throws ApiError
     */
    public static getWireframeDataApiV1AdminWireframeDataGet(
        timeframe: string = '',
    ): CancelablePromise<WireframeDataResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/wireframe/data',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Get Wireframe Report
     * Read-only Finance dashboard report, computed from the current inputs.
     * @param timeframe H1 FY26 or H2 FY26 planning root.
     * @param view full: the entered inputs; adjusted: the inputs less their adjustments.
     * @returns WireframeReportResponse Successful Response
     * @throws ApiError
     */
    public static getWireframeReportApiV1AdminWireframeReportGet(
        timeframe: string = '',
        view: 'full' | 'adjusted' = 'full',
    ): CancelablePromise<WireframeReportResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/wireframe/report',
            query: {
                'timeframe': timeframe,
                'view': view,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Cost Profiles
     * @param timeframe
     * @param includeArchived
     * @returns CostProfileRead Successful Response
     * @throws ApiError
     */
    public static listCostProfilesApiV1AdminWireframeCostProfilesGet(
        timeframe: string = '',
        includeArchived: boolean = false,
    ): CancelablePromise<Array<CostProfileRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/wireframe/cost-profiles',
            query: {
                'timeframe': timeframe,
                'include_archived': includeArchived,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Cost Profile
     * @param requestBody
     * @param timeframe
     * @returns CostProfileRead Successful Response
     * @throws ApiError
     */
    public static createCostProfileApiV1AdminWireframeCostProfilesPost(
        requestBody: CostProfileCreate,
        timeframe: string = '',
    ): CancelablePromise<CostProfileRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/wireframe/cost-profiles',
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Update Cost Profile
     * @param profileId
     * @param requestBody
     * @param timeframe
     * @returns CostProfileRead Successful Response
     * @throws ApiError
     */
    public static updateCostProfileApiV1AdminWireframeCostProfilesProfileIdPut(
        profileId: number,
        requestBody: CostProfileUpdate,
        timeframe: string = '',
    ): CancelablePromise<CostProfileRead> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/admin/wireframe/cost-profiles/{profile_id}',
            path: {
                'profile_id': profileId,
            },
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Archive Cost Profile
     * @param profileId
     * @param timeframe
     * @returns CostProfileRead Successful Response
     * @throws ApiError
     */
    public static archiveCostProfileApiV1AdminWireframeCostProfilesProfileIdArchivePost(
        profileId: number,
        timeframe: string = '',
    ): CancelablePromise<CostProfileRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/wireframe/cost-profiles/{profile_id}/archive',
            path: {
                'profile_id': profileId,
            },
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Cost Profile Assignments
     * @param requestBody
     * @param timeframe
     * @returns AssignmentsPatchResponse Successful Response
     * @throws ApiError
     */
    public static patchCostProfileAssignmentsApiV1AdminWireframeCostProfileAssignmentsPatch(
        requestBody: AssignmentsPatch,
        timeframe: string = '',
    ): CancelablePromise<AssignmentsPatchResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/admin/wireframe/cost-profile-assignments',
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Orgs
     * Active orgs of the half, by name ignoring case.
     * @param timeframe
     * @returns OrgRead Successful Response
     * @throws ApiError
     */
    public static listOrgsApiV1AdminWireframeOrgsGet(
        timeframe: string = '',
    ): CancelablePromise<Array<OrgRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/wireframe/orgs',
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Create Org
     * @param requestBody
     * @param timeframe
     * @returns OrgRead Successful Response
     * @throws ApiError
     */
    public static createOrgApiV1AdminWireframeOrgsPost(
        requestBody: OrgCreate,
        timeframe: string = '',
    ): CancelablePromise<OrgRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/wireframe/orgs',
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Archive Org
     * Archives an org; fails while any workstream is assigned to it.
     * @param orgId
     * @param timeframe
     * @returns OrgRead Successful Response
     * @throws ApiError
     */
    public static archiveOrgApiV1AdminWireframeOrgsOrgIdArchivePost(
        orgId: number,
        timeframe: string = '',
    ): CancelablePromise<OrgRead> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/admin/wireframe/orgs/{org_id}/archive',
            path: {
                'org_id': orgId,
            },
            query: {
                'timeframe': timeframe,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Org Assignments
     * @param requestBody
     * @param timeframe
     * @returns OrgAssignmentsPatchResponse Successful Response
     * @throws ApiError
     */
    public static patchOrgAssignmentsApiV1AdminWireframeOrgAssignmentsPatch(
        requestBody: OrgAssignmentsPatch,
        timeframe: string = '',
    ): CancelablePromise<OrgAssignmentsPatchResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/admin/wireframe/org-assignments',
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Patch Wireframe Headcount Data
     * @param requestBody
     * @param timeframe
     * @returns HeadcountPatchResponse Successful Response
     * @throws ApiError
     */
    public static patchWireframeHeadcountDataApiV1AdminWireframeHeadcountDataPatch(
        requestBody: HeadcountPatch,
        timeframe: string = '',
    ): CancelablePromise<HeadcountPatchResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/admin/wireframe/headcount-data',
            query: {
                'timeframe': timeframe,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Wireframe Audit
     * @param timeframe
     * @param limit
     * @returns WireframeAuditRead Successful Response
     * @throws ApiError
     */
    public static listWireframeAuditApiV1AdminWireframeAuditGet(
        timeframe: string = '',
        limit: number = 100,
    ): CancelablePromise<Array<WireframeAuditRead>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/admin/wireframe/audit',
            query: {
                'timeframe': timeframe,
                'limit': limit,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
